<template>
  <div class="CollectionId">
    <div ref="CollectionHeader">
      <CollectionHeader
        :detail="detail"
      />
    </div>

    <!-- 大专题 -->
    <template v-if="collectionType == 'large'">

      <CollectionList
        :list="listByLarge"
        @downloadFree="downloadFree"
        @download="downloadFree"
        @downloadSourceFiles="downloadSourceFiles"
        @buyBusinessVip="buyBusinessVip"
        @buyTupianPackage="buyTupianPackage"
        @downloadTupianPackage="downloadTupianPackage"
        @downloadTupianPackageSourceFiles="downloadTupianPackageSourceFiles"

      />

<!--                v-show="collectRecommend.length && isLogin"
-->
      <div class="CollectionRecommend">
        <CollectionRecommend
          topicTitle="更多精选专题"
          v-show="collectRecommend.length "
          :pic-list="collectRecommend"
          @picItemTopicClick="picItemTopicClick"
          @topicMouseover="topicMouseover"
        />
      </div>


    </template>

    <!--  小专题 -->
    <div v-if="collectionType == 'small'">
      <div class="inner_center">
        <div class="pic-list-wrap">
          <!--          <PicList :pic-list="list"/>-->
          <!--          <TupianList
                      :tupian-list="list"
                      @downloadFree="downloadFree"
                      @download="downloadFree"
                      @downloadSourceFiles="downloadSourceFiles"
                      @buyBusinessVip="buyBusinessVip"
                      @buyTupianPackage="buyTupianPackage"
                      @downloadTupianPackage="downloadTupianPackage"
                      @downloadTupianPackageSourceFiles="downloadTupianPackageSourceFiles"
                    >
                    </TupianList>-->

          <PicList :pic-list="list" v-bind="$attrs"
                   v-on="$listeners"/>
        </div>
        <div class="pagination-box">
          <CtPagination
            v-if="pagination.totalPage > 1"
            :total-page="pagination.totalPage"
            :paper-count="5"
            :current-page="pagination.page"
            class="CtPagination"
            @pageClick="pageClick"
          />
        </div>
      </div>
      <div class="CollectionRecommend">
        <CollectionRecommend
          v-show="collectRecommend.length"
          :pic-list="collectRecommend"
          topicTitle="更多精选专题"
          @picItemTopicClick="picItemTopicClick"
          @topicMouseover="topicMouseover"
        />
      </div>
    </div>


    <!-- <websiteRatingModel/> -->

    <no-ssr>
<!--      <NoLoginBar/>-->

            <ActSlot />

      <div class="showCollectModal"
           :class="[
             { 'ON': isScrolling && collectionType == 'large' },
             { 'ON-small': isScrolling && collectionType != 'large' },

             ]"
      >
        <div class="content">
          <!--          isScrolling {{ isScrolling }}-->

          订阅后可在<a :href="
          companyAccountStatus == 0 ? USER_CENTER_COLLECT_RECORD_TOPIC : '/company/collect-record?vipTypeId=3'
" target="_blank">收藏记录</a>里快速找到我~
          <div class="btn" @click="collect">订阅</div>


        </div>
      </div>

    </no-ssr>

  </div>
</template>

<script>
import CollectionHeader from '@/components/collection/collection-header';
import CollectionList from '@/components/collection/collection-list';
import CollectionRecommend from '@/components/collection/collection-recommend';
import NoLoginBar from '@/components/common/login/no-login-bar'
import {listObjToArray, setListType} from "@/components/tupian/common/list";
import {fnBrowser, fnLayout, fnLogin, fnRouter, fnTopic} from "@/fn";
import PicList from '@/components/pic/pic-list/pic-list';
import {
  getCollectionListByLarge,
  getCollectionList,
  getTopicRecommend,
  getCollectionStat,
  toggleTopicCollect
} from "@/api/topic";
import {BackToTop, CtPagination, PublicHeader} from "@/components/common/index.js"
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import {fnCollection} from "@/fn";
import downloadMixin from "@/pages/collection/downloadMixin";
import TupianList from "@/components/tupian/tupian-list"
import {mapState} from "vuex";
import {parseListUrl} from "@/components/list/module";
import {TOPIC} from "@/constant/tupian/TOPIC";
import mixin from "@/pages/collection/mixin";

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';
// import ActLoginCouponBar from '@/components/_Privately/Act/ActLoginCouponBar'
import ActSlot from '@/components/_Privately/Act/ActSlot'
import {USER_CENTER_COLLECT_RECORD_TOPIC} from "@/constant/_Public/Path";
import {completeTaskByFanClub} from "@/api/fans/club";


export default {
  name: "CollectionId",
  layout: "header-nav",
  mixins: [downloadMixin, mixin],
  components: {
    CollectionHeader,
    CollectionList,
    CollectionRecommend,
    PicList,
    CtPagination,
    TupianList,
    NoLoginBar,
    // ActLoginCouponBar,
    ActSlot
  },
  computed: {
    ...mapState('user', ['isLogin', 'downloadCount', 'companyAccountStatus'])
  },
  head() {
    return {
      title: this.tkd.title,
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.tkd.keywords
        },
        {
          hid: 'description',
          name: 'description',
          content: this.tkd.description
        },
        {
          property: 'article:published_time',
          content: this.published_time
        }
      ]
    }
  },
  watch: {
    isLogin(n, o) {
      if (n || n == true || n == false) {
        this.initFooter();
      }
    },

    collectionId: {
      handler(n) {
        if (n > 0) {
          getCollectionStat({position: 'glance', id: this.collectionId}).then(res => {
          })
        }
      }
    }
  },
  data() {
    return {
      USER_CENTER_COLLECT_RECORD_TOPIC,
      id: this.$route.params.id || this.$route.query.id,
      collectionType: -1,
      collectionId: -1,
      collectRecommend: [],
      detail: {}, // 合集信息
      /* 大合集 */
      listByLarge: [],
      /* 小合集 */
      list: [],
      pagination: {
        totalPage: 1,
        page: 1
      },
      tkd: {},
      showCollect: true, // 显示订阅弹框

      isScrolling: false,
      scrollTimer: null,
      timer: null
    }
  },
  async asyncData({app}) {
    let UA = app.context.req.headers['user-agent'];

    const {route} = app.context;
    let id = route.params.id;


    var currentRoutePath = CON_COMMON.CON_BASIC.BASE_URL + route.path;

    console.log(currentRoutePath)

    if (fnCollection.isLarge(id)) {
      // console.log('-- Large --')
      let temp = fnCollection.parseCollectionId(id);
      let [listByLarge, collectRecommend, collectStatus] = await Promise.all([
        app.$api.getCollectionListByLarge({id: temp.collectionId}),
        app.$api.getTopicRecommend({id: temp.collectionId}),
        app.$api.getTopicCollectStatus({id: temp.collectionId}),
      ])
      let {master, tkd, childs} = listByLarge.data;
      if (collectStatus.status == 200) {
        master.isCollect = parseInt(collectStatus.data.is_there) === 1 ? true : false
      } else {
        master.isCollect = false
      }
      console.log(listByLarge)

      return {
        detail: master,
        tkd: tkd,
        listByLarge: fnCollection.disposeListByLarge(childs, temp, currentRoutePath),
        collectRecommend: fnCollection.disposeRecommendList(collectRecommend.data),
        isSpider: fnBrowser.isSpider(UA),
        collectionType: 'large'
      }

    } else {
      // getCollectionList
      let temp = fnCollection.parseCollectionId(id);
      let [list, collectStatus, collectRecommend] = await Promise.all([
        app.$api.getCollectionList({id: temp.collectionId, page: temp.page}),
        app.$api.getTopicCollectStatus({id: temp.collectionId}),
        app.$api.getTopicRecommend({id: temp.collectionId}),
      ])


      let {page, pages, master, pictures, tkd} = list.data;
      if (collectStatus.status == 200) {
        master.isCollect = parseInt(collectStatus.data.is_there) === 1 ? true : false
      } else {
        master.isCollect = false
      }
      let _list = listObjToArray(pictures)
      return {
        detail: master,
        tkd: tkd,
        list: _list,
        pagination: {totalPage: pages, page: page},
        isSpider: fnBrowser.isSpider(UA),
        collectRecommend: fnCollection.disposeRecommendList(collectRecommend.data),
        collectionType: 'small'
      }

    }
  },

  async mounted() {
    window.addEventListener("scroll", this.handleScroll);
    await this.parseId();
    await this.initQuery();
    // await this.initFooter();
    await this.topicPositionStat();
  },
  methods: {
    initFooter() {
      if (!fnLogin.checkLogin()) {
        document.getElementById('FooterWrap').style.display = 'none';
      } else {
        document.getElementById('FooterWrap').style.display = 'block';
      }
    },
    //用&拼接对象成字符串
    getParams(params) {
      let paramStr = '';
      Object.keys(params)
        .forEach((item) => {
          if (paramStr === '') {
            paramStr = `${item}=${params[item]}`;
          } else {
            paramStr = `${paramStr}&${item}=${params[item]}`;
          }
        });
      return paramStr;
    },

    initQuery() {
      this.queryParams = this.getParams(this.$route.query)
    },

    async parseId() {
      /* 判断是否合集类型是大专题还是小专题 */
      this.id = this.id.replace('.html', '');
      if (this.id.indexOf('large') > -1) {
        /* 大专题 无分页 */
        let idArr = this.id.split('-');
        this.collectionId = idArr[0]
        // this.collectionType = 'large';
        fnLayout.setFooterBgColor();


        // this.getCollectionListByLarge();
        // this.getTopicRecommend();
      } else {
        /* 小专题 */
        let idArr = this.id.split('-');
        this.collectionId = idArr[0]
        this.pagination.page = idArr[1] || 1;
        // this.collectionType = 'small'

        // this.getCollectionList();
      }


    },


    getCollectionListByLarge() {
      getCollectionListByLarge({
        id: this.collectionId
      }).then(res => {
        console.log(res);
        let {data} = res.data;
        this.listByLarge = listObjToArray(data.childs);
        this.listByLarge.forEach(vo => {
          vo.pictures = listObjToArray(vo.pictures);
        })
        this.detail = res.data.data.master
      })
    },

    getTopicRecommend() {
      getTopicRecommend({
        id: this.collectionId
      }).then(res => {
        console.log(res)
        this.collectRecommend = res.data.data;
        this.collectRecommend.forEach(vo => {
          vo.type = 3;
          vo.proto_pic = vo.cover_img
          if (vo.childs && vo.childs > 0) {
            vo.link_url = `${PAGE_PATH.BASE_URL}${PAGE_PATH.TOPIC.COLLECTION}/${vo.id}-large.html`
          } else {
            vo.link_url = `${PAGE_PATH.BASE_URL}${PAGE_PATH.TOPIC.COLLECTION}/${vo.id}.html`
          }
        })
      })
    },

    getCollectionList() {
      getCollectionList({
        id: this.collectionId,
        page: this.pagination.page
      }).then(res => {
        console.log(res.data.data);

        let {data} = res.data;
        this.list = listObjToArray(data.pictures)

        /* 封面信息 */
        this.detail = data.master;
        this.pagination.page = data.page
        this.pagination.totalPage = data.pages

      })
    },

    pageClick(page) {
      this.pagination.page = page;
      let path;
      if (page > 1) {
        path = PAGE_PATH.BASE_URL + PAGE_PATH.TOPIC.COLLECTION + '/' + this.collectionId + '-' + page + '.html';
      } else {
        path = PAGE_PATH.BASE_URL + PAGE_PATH.TOPIC.COLLECTION + '/' + this.collectionId + '.html';
      }

      path = this.queryParams ? path + '?' + this.queryParams : path;
      fnRouter.navigationTo(path, '_self')
    },

    topicPositionStat() {

      if (this.collectionType == 'large') {
        if (this.collectRecommend.length) {
          let ids = this.collectRecommend.map(item => item.id)
          ids.push(this.detail.id)
          fnTopic.positionStat(
            ids.toString(),
            TOPIC.POSITION_STAT.EVENT.EXPOSE,
            TOPIC.POSITION_STAT.POSITION.TOPIC_BOTTOM,
          )
        }
      } else {
        fnTopic.positionStat(
          this.detail.id,
          TOPIC.POSITION_STAT.EVENT.EXPOSE,
          TOPIC.POSITION_STAT.POSITION.COLLECTION,
        )
      }
    },

    picItemTopicClick(topicId) {
      fnTopic.positionStat(
        topicId,
        TOPIC.POSITION_STAT.EVENT.CLICK,
        TOPIC.POSITION_STAT.POSITION.TOPIC_BOTTOM,
      )
    },

    topicMouseover(topicId) {
      fnTopic.positionStatMouseOver(
        topicId, TOPIC.POSITION_STAT.POSITION.TOPIC_BOTTOM,
      )
    },

    handleScroll() {
      /* 超过头部开始计算 */
      let headHeight = this.$refs.CollectionHeader.offsetHeight;
      console.log(headHeight)
      this.scrollTop = document.documentElement.scrollTop;
      this.isScrolling = false;
      this.timer = null;
      clearTimeout(this.timer);

      console.log('当前滚动距离' + this.scrollTop + 'TIMER' + this.timer);

      if (this.detail.isCollect) {
        return false;
      }

      if (this.scrollTop > headHeight) {
        /* 每1s检查一次，滚动条是否变化 */
        this.timer = setTimeout(() => {
          this.timer = null;
          clearTimeout(this.timer);
          this.isScrolling = true
        }, 2500)
      } else {
        this.timer = setTimeout(() => {
          this.timer = null;
          clearTimeout(this.timer);
          this.isScrolling = false
        }, 2500)
      }


      /*this.isScrolling = true;

      // Clear the previous timer

      // Set a new timer to reset isScrolling after a delay
      this.scrollTimer = setTimeout(() => {
        this.isScrolling = false;
        clearTimeout(this.scrollTimer);
      },  3000); // Adjust the delay as needed*/
    },
    checkScrollingStatus() {
      if (this.isScrolling) {
        console.log('User is continuously scrolling.');
      } else {
        console.log('User has stopped scrolling.');
        this.scrollTimer = null;
        clearTimeout(this.scrollTimer);
      }

      // Check again after a delay
      setTimeout(this.checkScrollingStatus, 500); // Adjust the delay as needed
    },

    collect() {
      if (fnLogin.checkLogin()) {
        let vo = this.detail;
        let isCollect = vo.isCollect || false
        toggleTopicCollect({
          id: vo.id,
          mode: isCollect === false ? 'add' : 'rem'
        }).then(res => {
          let {status} = res.data;
          console.log(status)

          if (status == 200) {
            let msg = isCollect === false ? '订阅成功' : '已取消订阅';
            /* 订阅人数修改 */
            let tempSubscribe = parseInt(vo.subscribe);
            tempSubscribe = isCollect === false ? (tempSubscribe += 1) : (tempSubscribe -= 1)
            this.$set(vo, 'isCollect', !vo.isCollect)
            this.$set(vo, 'subscribe', tempSubscribe)
            this.$myNotify.success(msg, () => {
              this.isScrolling = false;
            });

            /* 检查是否是领取任务 */
            setTimeout(() => {
              let {id, task_type} = this.$route.query
              if (task_type == 1) {
                completeTaskByFanClub({id}).then(res => {
                  let {status, data, message} = res.data;
                  if (status == 200) {
                    this.$myNotify.success("任务已完成")
                    this.$router.push({
                      query: {}
                    })
                  } else {
                    this.$myNotify.error(message)

                  }
                })
              }
            }, 1000)

          } else if (status == 405) {
            this.$myNotify.success('已订阅');
            this.$set(vo, 'isCollect', true)


          }
        })
      } else {
        fnLogin.loginIntercept('请先登录');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.CollectionId {
  .pic-list-wrap {
    margin: 40px 0 35px;
  }

  /deep/ .ct-pagination {
    margin: 0 0 64px;
  }

}

.CollectionRecommend {
  width: 100%;
}

.showCollectModal {

  position: fixed;
  top: -990px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  transition: all 1s ease;

  &.ON {
    top: 160px;
  }

  &.ON-small {
    top: 90px;
  }

  .content {
    width: 417px;
    height: 64px;
    background: #F94D67;
    border-radius: 8px;
    font-size: 14px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      text-decoration: underline;
      cursor: pointer;
      margin: 0 4px;
      color: #FFFFFF;
    }

    .btn {
      width: 100px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      background: #FFFFFF;
      border-radius: 24px;
      font-size: 14px;
      color: #F94D67;
      margin-left: 40px;
      cursor: pointer;

      &:hover {
        background: rgba(255, 255, 255, 0.9);
      }
    }
  }

}
</style>
